var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyArticlesIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon my-article-icon",
    viewBox: "9 10 22 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-articles-icon-sv_svg__a",
    width: "108.4%",
    height: "161.4%",
    x: "-4.2%",
    y: "-30.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF8000",
    fillRule: "evenodd",
    filter: "url(#my-articles-icon-sv_svg__a)",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14a.75.75 0 01.102 1.493l-.102.007h-7.5a1.25 1.25 0 00-1.244 1.122l-.006.128v12.5c0 .647.492 1.18 1.122 1.243l.128.007h12.5a1.25 1.25 0 001.244-1.122l.006-.128v-7.5a.75.75 0 011.493-.102l.007.102v7.5a2.75 2.75 0 01-2.582 2.745L25.25 32h-12.5a2.75 2.75 0 01-2.745-2.583L10 29.25v-12.5a2.75 2.75 0 012.582-2.745L12.75 14h7.5zm7.016-2a2.734 2.734 0 012.06 4.53l-.127.137-9.406 9.406a.714.714 0 01-.177.13l-.102.042-4.285 1.429a.722.722 0 01-.45 0 .714.714 0 01-.477-.81l.025-.094 1.428-4.284a.722.722 0 01.1-.196l.072-.084 9.406-9.405A2.714 2.714 0 0127.266 12zM17.103 23.164l-.862 2.589 2.587-.864-1.725-1.725zM27.261 13.5c-.282 0-.55.094-.768.268l-.104.094-8.234 8.232 1.745 1.745 8.233-8.233c.45-.45.48-1.16.09-1.644l-.09-.1a1.234 1.234 0 00-.733-.354l-.14-.008z"
  }))));
}

export default SvgMyArticlesIconSv;